import { render } from "./SubAccountDetail.vue?vue&type=template&id=2641fd57"
import script from "./SubAccountDetail.vue?vue&type=script&lang=js"
export * from "./SubAccountDetail.vue?vue&type=script&lang=js"
script.render = render

export default script